'use client';
import React, { forwardRef } from 'react';
import CommonHeader from './CommonHeader.mjs';
import HeaderName from './HeaderName.mjs';
import { HeaderNpayButton } from './HeaderNpayButton.mjs';
import { NF_HEADER_TYPE } from '../../constants/global.mjs';
import useApplyLogging from '../../hooks/useApplyLogging.mjs';
import useHeaderBrandLogo from '../../hooks/useHeaderBrandLogo.mjs';

/**
 * ## 5탭 헤더
 *
 * ### `GlobalConfig` 설정
 * - HeaderBrandMain에서 바라보는 도메인을 변경하고자 한다면 `GlobalConfig`의 `setPayDomain`, `setStockDomain`, `setRealEstateDomain`, `setInsuranceDomain` (으)로 전역에 지정할 수 있습니다.
 * - [GlobalConfig docs 바로가기](https://oss.fin.navercorp.com/pages/finance-fe/deFign/v7/?path=/docs/getting-started--docs#globalconfig)
 */
const HeaderBrandMain = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    serviceType,
    serviceTypeRef,
    rightComponent,
    bgColor = 'white',
    brandLogo = [],
    href,
    isMobile,
    isPayApp,
    ...props
  } = _ref;
  useApplyLogging('HeaderBrandMain');
  const {
    nLogo,
    payLogo
  } = useHeaderBrandLogo(brandLogo);
  return /*#__PURE__*/React.createElement(CommonHeader, {
    align: "left",
    bgColor: bgColor,
    rightComponent: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: "blind"
    }, "\uBA54\uB274\uBAA8\uC74C"), rightComponent),
    ref: ref
  }, /*#__PURE__*/React.createElement("h1", null, /*#__PURE__*/React.createElement(HeaderNpayButton, {
    n: nLogo,
    pay: payLogo,
    isMobile: isMobile,
    isPayApp: isPayApp
  }), /*#__PURE__*/React.createElement(HeaderName, {
    serviceType: serviceType,
    headerType: NF_HEADER_TYPE.MAIN,
    href: href,
    ...props,
    ref: serviceTypeRef
  })));
});
HeaderBrandMain.displayName = 'HeaderBrandMain';

export { HeaderBrandMain as default };
